import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { actionAfterSubmit, actionAfterSubmitText } from '../model/types';
import { isSSR } from '../utils/helpers';
import { StorageHelperKeys, getLocalStorageItem, setLocalStorageItem } from '../utils/storageHelpers';

const getActionAfterSubmit: () => actionAfterSubmit = () =>
    isSSR() ? 'stay' : getLocalStorageItem(StorageHelperKeys.ACTION_AFTER_SUBMIT);

const ActionAfterSubmitMenu = () => {
    const { t } = useTranslation('tickets');

    const actionAfterSubmit = getActionAfterSubmit();

    const [selectedKeys, setSelectedKeys] = useState<actionAfterSubmit[]>([actionAfterSubmit]);

    const items = Object.keys(actionAfterSubmitText).map((action) => ({
        key: action,
        label: t('actionAfterSubmitButton', { context: action }),
        value: action,
        onClick: ({ key }) => {
            setLocalStorageItem(StorageHelperKeys.ACTION_AFTER_SUBMIT, key);
            setSelectedKeys([key as actionAfterSubmit]);
        }
    }));

    return (
        <Dropdown menu={{ items, selectedKeys }} trigger={['click']}>
            <Button type="text">
                {t('actionAfterSubmitButton', { context: actionAfterSubmit })} <DownOutlined />
            </Button>
        </Dropdown>
    );
};

export default ActionAfterSubmitMenu;
